export default function ActionBlockTemplate(data) {
	//language=HTML
	return `
		<div id="actionButtons" class="info-body row w-100 m-auto align-items-center">
		</div>
	`;
}